import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import cellImage from "../../assets/Battery-cells.svg";
import { Loader } from "../Loaders/loader";
import axios from "axios";
import ImpedanceGraph from "./ImpedanceGraph";
import CircuitParameters from "./CircuitParameters";
import "./cellInfo.css";
// import BatteryCard from "../Cards/BatteryCard";
import BarcodeCard from "../Cards/BarcodeCard";
import CellImageCard from "../Cards/CellImageCard";
import HppcGraph from "./HppcGraph";
import ChargeDischargeGraph from "./ChargeDischargeGraph";
import CyclePlot from "./CyclePlot";

export const CellInfo = () => {
  const { cellId } = useParams();
  const [cellData, setCellData] = useState({
    battery_id: "",
    meta: {},
    electrical_properties: {},
    mechanical_properties: {},
    cell_images: [],
    cell_csvs: [],
  });
  const [ImpedanceCsvData, setImpedanceCsvData] = useState("");
  const [HppcCsvData, setHppcCsvData] = useState("");
  const [CycleCsvData, setCycleCsvData] = useState("");
  const [CellImage, setCellImage] = useState("");

  // useEffect(() => {
  //   const getCellData = async () => {
  //     const response = await axios.get(`${process.env.BACKEND_URL}batteries/id/${cellId}`);
  //     setCellData(response.data);
  //     setImpedanceCsvData(response.data.cell_csvs[0].csv_path);
  //     setHppcCsvData(response.data.cell_csvs[1].csv_path);
  //     setCycleCsvData(response.data.cell_csvs[2].csv_path);
  //     setCellImage(response.data.cell_images[0].image_path);
  //   };
  //   getCellData();
  // }, [cellId]);

  useEffect(() => {
    const getCellData = async () => {
      try {
        const response = await axios.get(`${process.env.BACKEND_URL}batteries/id/${cellId}`);
        const data = response.data;

        setCellData(data);
        
        if (data.cell_csvs && data.cell_csvs.length > 0) {
          setImpedanceCsvData(data.cell_csvs[0]?.csv_path || "");
          setHppcCsvData(data.cell_csvs[1]?.csv_path || "");
          setCycleCsvData(data.cell_csvs[2]?.csv_path || "");
        }

        if (data.cell_images && data.cell_images.length > 0) {
          setCellImage(data.cell_images[0]?.image_path || "");
        }
      } catch (error) {
        console.error("Failed to fetch cell data:", error);
      }
    };
    getCellData();
  }, [cellId]);

  const downloadFile = async (file) => {
    const response = await axios.get(`${process.env.BACKEND_URL}files/${file}`, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file);
    document.body.appendChild(link);
    link.click();
  };

  if (!cellData.meta && !cellData.electrical_properties) {
    return <Loader />;
  }

  return (
    <>
      <div className="flex flex-col xl:flex-row xl:justify-between items-center w-[100%] pt-12 pb-8 px-0 xl:px-20 gap-10 xl:gap-0 max-w-[1400px] mx-auto">
        <div className="flex flex-col justify-center items-center w-[100%]">
          {CellImage && <CellImageCard cellImage={CellImage} />}
        </div>
        <div className="flex flex-col justify-center items-center w-[100%]">
          {cellData.battery_id && <BarcodeCard batteryId={cellData.battery_id} />}
        </div>
        <div className="flex flex-col justify-center items-center w-[100%]">
          <div className="bg-white w-[350px] h-[320px] rounded-lg p-5 cursor-pointer shadow-[0px_0px_11px_0px_#e8442d]">
            <div className="text-[#e8442d] mb-4 text-center">Cell Information:</div>
            <div className="border-[0.5px] border-[#e8432d3e] shadow-md p-4 rounded-md w-[100%]">
              <table className="w-full ">
                <tbody className="w-full">
                  {Object.keys(
                    cellData.meta &&
                      cellData.electrical_properties && {
                        ...cellData.meta,
                        ...cellData.electrical_properties,
                      },
                  )
                    .filter((key) =>
                      ["manufacturer", "capacity", "nominal_voltage", "soh", "price"].includes(key),
                    )
                    .map((key) => (
                      <tr key={key} className="w-full border-b-[0.5px] border-[#e8432d3e] my-2">
                        <td className="font-bold text-base md:text-lg border-r-[0.5px] border-[#e8432d3e] pr-9">
                          {key === "soh"
                            ? "SoH"
                            : key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")}
                        </td>
                        <td className="pl-4 text-base md:text-lg">
                          {cellData.meta[key] || cellData.electrical_properties[key]}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {(cellId && CycleCsvData) ? (
        <CyclePlot
          cellId={cellId}
          CellCycleData={CycleCsvData}
          downloadFile={downloadFile}
        />
      ) : (
        <Loader />
      )}

      <div className="flex flex-col items-start w-[100%] md:w-[60%] pt-12 pb-8 px-0 gap-10 md:px-10 max-w-[1400px] mx-auto">
        <div className="flex flex-col justify-center items-center gap-2 w-[100%]">
          <h1 className="text-2xl text-[#e8442d] max-md:text-xl max-xsm:text-lg text-center mb-6">
            Meta Information:
          </h1>
          <div className="border-[0.5px] border-[#e8432d3e] shadow-md p-4 rounded-md w-[100%]">
            {cellData.meta && cellData.mechanical_properties && (
              <table className="w-full">
                <tbody className="w-full">
                  {Object.keys({ ...cellData.meta, ...cellData.mechanical_properties })
                    .filter((key) =>
                      [
                        "cell_characterization_date",
                        "cell_condition",
                        "diameter",
                        "energy_density_galvanometric",
                        "energy_density_volumetric",
                        "formFactor",
                        "height",
                        "manufacturer",
                        "mass",
                        "model",
                        "soh",
                        "type",
                        "volume",
                      ].includes(key),
                    )
                    .map((key) => (
                      <tr key={key} className="w-full border-b-[0.5px] border-[#e8432d3e] my-2">
                        <td className="font-bold text-base md:text-lg border-r-[0.5px] border-[#e8432d3e] pr-9">
                          {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")}
                        </td>
                        <td className="pl-4 text-base md:text-lg">
                          {cellData.meta[key] || cellData.mechanical_properties[key]}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-6 w-[100%]">
          <h1 className="text-2xl text-[#e8442d] max-md:text-xl max-xsm:text-lg text-center mb-6">
            Electrical Parameters:
          </h1>
          <div className="border-[0.5px] border-[#e8432d3e] shadow-md p-4 rounded-md w-[100%]">
            {cellData.electrical_properties && (
              <table className="w-full">
                <tbody className="w-full">
                  {Object.keys({ ...cellData.electrical_properties })
                    .filter((key) =>
                      [
                        "capacity",
                        "current_continuous",
                        "nominal_charge_capacity",
                        "nominal_energy",
                        "nominal_voltage",
                        "peak_current",
                        "power_continuous",
                        "power_peak",
                        "voltage_range",
                      ].includes(key),
                    )
                    .map((key) => (
                      <tr key={key} className="w-full border-b-[0.5px] border-[#e8432d3e] my-2">
                        <td className="font-bold text-base md:text-lg border-r-[0.5px] border-[#e8432d3e] pr-9">
                          {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")}
                        </td>
                        <td className="pl-4 text-base md:text-lg">
                          {cellData.electrical_properties[key]}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-6 w-[100%] mb-20">
        <h1 className="text-2xl text-center my-10">Download Files:</h1>
        <div className="table-container">
          <table className="table w-full">
            <tbody className="w-full">
              <tr>
                <td className="font-bold text-md">Impedance CSV</td>
                <td>
                  {cellData.cell_csvs?.length > 0 && cellData.cell_csvs[0].csv_path && (
                    <a
                      className="bg-[#d98532] text-white px-4 py-2 rounded-md cursor-pointer"
                      onClick={() => downloadFile(cellData.cell_csvs[0].csv_path)}
                    >
                      Download
                    </a>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {(cellId && ImpedanceCsvData) ? (
        <ImpedanceGraph
          cellId={cellId}
          ImpedanceCsvData={ImpedanceCsvData}
          downloadFile={downloadFile}
        />
      ) : (
        <Loader />
      )}

      {(cellId && HppcCsvData) ? (
        <HppcGraph
          cellId={cellId}
          HppcCsvData={HppcCsvData}
          downloadFile={downloadFile}
        />
      ) : (
        <Loader />
      )}

      {(cellId && HppcCsvData) ? (
        <ChargeDischargeGraph
          cellId={cellId}
          HppcCsvData={HppcCsvData} 
          downloadFile={downloadFile}
        />
      ) : (
        <Loader />
      )}

      {cellId ? <CircuitParameters cellId={cellId} /> : <Loader />}
    </>
  );
};
